var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfferRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 59,
    viewBox: "0 0 62 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 36925",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_i_2670_50952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8134 68.1349C20.3928 68.5958 17.2132 66.2976 16.5968 62.9188L15.8388 58.7634C15.6215 57.5725 14.871 56.5448 13.7996 55.9713L10.0612 53.9699C7.02161 52.3426 5.80709 48.6241 7.30474 45.5302L9.14666 41.7251C9.67453 40.6346 9.67453 39.3644 9.14666 38.2739L7.30474 34.4688C5.80709 31.3749 7.02161 27.6563 10.0612 26.0291L13.7996 24.0277C14.871 23.4542 15.6215 22.4265 15.8388 21.2356L16.5968 17.0801C17.2132 13.7014 20.3928 11.4032 23.8134 11.8641L28.0203 12.431C29.2259 12.5934 30.4403 12.2009 31.3197 11.3645L34.3882 8.44594C36.8832 6.0729 40.8135 6.0729 43.3084 8.44594L46.3769 11.3645C47.2563 12.2009 48.4707 12.5934 49.6764 12.431L53.8833 11.8641C57.3038 11.4032 60.4835 13.7014 61.0998 17.0801L61.1703 17.4665C61.8221 21.0392 64.0737 24.1223 67.2878 25.843L67.6354 26.0291C70.6751 27.6563 71.8896 31.3749 70.3919 34.4688L68.55 38.2739C68.0221 39.3644 68.0221 40.6346 68.55 41.7251L70.3919 45.5302C71.8896 48.6241 70.6751 52.3426 67.6354 53.9699L63.8971 55.9713C62.8257 56.5448 62.0752 57.5725 61.8579 58.7634L61.0998 62.9188C60.4835 66.2976 57.3038 68.5958 53.8833 68.1349L49.6764 67.568C48.4707 67.4055 47.2563 67.7981 46.3769 68.6345L43.3084 71.553C40.8135 73.9261 36.8832 73.9261 34.3882 71.553L31.3197 68.6345C30.4403 67.7981 29.2259 67.4055 28.0203 67.568L23.8134 68.1349Z",
    fill: "url(#paint0_linear_2670_50952)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M33.3325 37.7774H48.8881M33.3325 30H48.8881M45.5547 55.5559L33.3325 45.5559L36.6659 45.5556C46.5429 45.5556 46.5429 30 36.6659 30",
    stroke: "white",
    strokeWidth: 4.44444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2670_50952",
    x: 6.66455,
    y: 6.66614,
    width: 64.3677,
    height: 66.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.33333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2670_50952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2670_50952",
    x1: 1.83697,
    y1: 3.3328,
    x2: 203.202,
    y2: 47.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#684EFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2064FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferRupee);
export default __webpack_public_path__ + "static/media/offer_rupee.c1fac56808fe54c2eca2596746d830f9.svg";
export { ForwardRef as ReactComponent };